import type { FrontendWidget } from '../types';
import { PricingTeaserComponent } from './PricingTeaserComponent';
import { PricingTeaserComponentB } from './PricingTeaserComponentB';
import { PricingTeaserComponentC } from './PricingTeaserComponentC';
import type { PricingTeaserConfig, PricingTeaserResolved } from './types';

export const pricingTeaserWidget: FrontendWidget<
  PricingTeaserConfig,
  PricingTeaserResolved
> = {
  componentType: 'widgets.pricing-teaser',
  displayName: 'Pricing Teaser',
  ComponentA: PricingTeaserComponent,
  ComponentB: PricingTeaserComponentB,
  ComponentC: PricingTeaserComponentC,
};
